import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/GLB_Teclado.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Teclado extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.3, -0.99, -1.6);
		this.scale.set(2.3, 2.3, 2.3);
		this.rotateY(-1.57)
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Teclado = gltf.scene.getObjectByName("Teclado", true);
			// Teclas
			this.A = gltf.scene.getObjectByName("Cube007", true);
			this.S = gltf.scene.getObjectByName("Cube032", true);
			this.F = gltf.scene.getObjectByName("Cube088", true);
			this.T = gltf.scene.getObjectByName("Cube024", true);
			this.F6 = gltf.scene.getObjectByName("Cube062", true);
			this.F8 = gltf.scene.getObjectByName("Cube064", true);
			this.Servicio = gltf.scene.getObjectByName("Cube057", true);
			this.RepetirArticulo = gltf.scene.getObjectByName("Cube006", true);
			this.Borrar = gltf.scene.getObjectByName("Cube030", true);
			this.F1 = gltf.scene.getObjectByName("Cube093", true);
			this.F11 = gltf.scene.getObjectByName("Cube072", true);
			this.Subtotal = gltf.scene.getObjectByName("Cube014", true);
			this.Control = gltf.scene.getObjectByName("Cube012", true);
			this.Mayus = gltf.scene.getObjectByName("Cube008", true);
			this.F3 = gltf.scene.getObjectByName("Cube055", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const tecladoFolder = gui.addFolder("Teclado");
		tecladoFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		tecladoFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		tecladoFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		tecladoFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		tecladoFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		tecladoFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		tecladoFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		tecladoFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		tecladoFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		tecladoFolder.add(this, "visible").name("visible");
	}
	onAnimateKeyboard() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.Teclado
		this.Teclado.material.emissive.set("#404040");

		this.animation = gsap.to(this.Teclado.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	onAnimateKeys() {
		this.onAnimate(this.A)
		this.onAnimate(this.S)
		this.onAnimate(this.F)
		this.onAnimate(this.T)
		this.onAnimate(this.F6)
		this.onAnimate(this.F8)
		this.onAnimate(this.Servicio)
		this.onAnimate(this.RepetirArticulo)
		this.onAnimate(this.Borrar)
	}
	onAnimateKeysQuizOne() {
		this.onAnimate(this.F1)
		this.onAnimate(this.F11)
		this.onAnimate(this.Subtotal)
	}
	onAnimate(object) {
		this.clearKeyAnimation(object)

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		// this.objectActiveAnimation = object
		object.material.emissive.set("#404040");

		object.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	clearKeyAnimation(object) {
		if (this.animation) {
			this.animation.kill();
		}
		if (object.animation) {
			object.animation.kill();
			object.material.emissive.set("#000000");
			object.material.emissiveIntensity = 0
		}
	}
	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
	onElevate(object) {
		this.restartElevation(object)
		object.animation = gsap.to(object.position, {
			y: 0.02,
			duration: 0.8,
			ease: "power1.inOut",
		});
		object.animation = gsap.to(object.scale, {
			y: 1.1,
			x: 1.1,
			z: 1.1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	restartElevation(object) {
		// console.log(object.position);
		if (object.position.y === 0.02) {
			object.position.y = 0.005814
			object.scale.x = 1
			object.scale.z = 1
			object.scale.y = 1
		}
	}
	restartElevationQuizOne() {
		this.restartElevation(this.F1)
		this.restartElevation(this.F11)
		this.restartElevation(this.Subtotal)
	}
	activityFiveQuizOneAnimation() {
		this.onAnimate(this.Mayus)
		this.onAnimate(this.Control)
		this.onAnimate(this.Borrar)
	}
	activityFiveQuizOneRestartElevation() {
		this.restartElevation(this.Mayus)
		this.restartElevation(this.Control)
		this.restartElevation(this.Borrar)
	}
	activityFiveQuizTwoAnimation() {
		this.onAnimate(this.F)
		this.onAnimate(this.F3)
		this.onAnimate(this.F1)
	}
	activityFiveQuizTwoRestartElevation() {
		this.restartElevation(this.F)
		this.restartElevation(this.F3)
		this.restartElevation(this.F1)
	}
	activityFiveQuizThreeAnimation() {
		this.onAnimate(this.T)
		this.onAnimate(this.F11)
		this.onAnimate(this.Subtotal)
	}
	activityFiveQuizThreeRestartElevation() {
		this.restartElevation(this.T)
		this.restartElevation(this.F11)
		this.restartElevation(this.Subtotal)
	}
}